var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "drag-drop-pdf" }, [
    _c(
      "div",
      {
        staticClass: "question-title-pdf",
        staticStyle: {
          "font-weight": "bold",
          "font-size": "14px",
          "padding-bottom": "8px",
          color: "#000",
        },
      },
      [_vm._v(" Câu " + _vm._s(_vm.question.index + 1) + ": ")]
    ),
    _vm.question.html
      ? _c("div", { staticClass: "mb-4 question-content-pdf" }, [
          _c("div", {
            staticClass: "processed-content",
            domProps: { innerHTML: _vm._s(_vm.renderContentWithAnswers) },
          }),
        ])
      : _vm._e(),
    _vm.optionsPool.length > 0
      ? _c("div", { staticClass: "mb-2 mt-2" }, [
          _c(
            "div",
            {
              staticClass: "font-weight-medium mb-1",
              staticStyle: { "font-size": "14px", "font-weight": "bold" },
            },
            [_vm._v("Danh sách lựa chọn:")]
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "block",
                width: "100%",
                "padding-left": "8px",
              },
            },
            _vm._l(_vm.optionsPool, function (opt) {
              return _c(
                "div",
                {
                  key: opt.key,
                  staticStyle: {
                    display: "inline-block",
                    "margin-right": "25px",
                    "margin-bottom": "5px",
                    "vertical-align": "top",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-right": "4px",
                        "font-size": "14px",
                      },
                    },
                    [_vm._v(_vm._s(opt.label) + ".")]
                  ),
                  _c("div", {
                    staticClass: "custom-inline-html",
                    staticStyle: {
                      display: "inline-block",
                      "font-size": "14px",
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.formatInlineHtml(opt.value)),
                    },
                  }),
                ]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }